<!--
 * @Autor: lianxiben
 * @Date: 2023-02-17 15:33:52
 * @LastEditors: lianxiben
 * @LastEditTime: 2023-02-24 09:57:32
-->
<template>
  <div class="page-container">
    <div class="home-page">
      <!-- 顶部栏 -->
      <div class="top-container">
        <div class="icon"></div>
        <div class="top-title">
          <div class="top-title-fir">提灯与地下城</div>
          <div class="top-title-sec">刷得爽的地牢养宠游戏</div>
        </div>

        <div class="btn-list">
          <div class="web-btn" @click="goWeb()"></div>
          <div class="down-btn" @click="goWeb()"></div>
        </div>
      </div>

      <div class="logo-container">
        <div class="small"></div>
        <div class="big"></div>
      </div>
      <div class="firework-container">
        <div class="firework-fir"></div>
        <div class="firework-sec"></div>
        <div class="firework-thr"></div>
        <div class="firework-four"></div>
      </div>
      <!-- <div class="ani"></div> -->
      <div class="bot-btn">
        <div class="xfyy" @click="goBookPage()"></div>
        <div class="znqs" @click="goActivty()"></div>
      </div>
    </div>
    <Footer :gameName="gameName" />
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import { init } from '../api';
import Footer from '@/components/Footer';
import { buriedLogger } from '@/utils/utils';
import {  mapActions } from 'vuex';
export default {
  components: {
    Footer
  },
  data () {
    return {
      list: {},
      gameName: 'tideng',
      record: ''
    }
  },
  created(){
    document.title = '提灯二周年庆典';
    this.initList()
    this.setShare({
      title: '提灯二周年庆典开启~',
      desc: '呼朋引伴赴新区，丰富游戏奖励等你参与~',
      imgUrl: 'https://download4.qcplay.com/tideng/active/anniversary_share_image_m.jpg'
    });
    const  bl = buriedLogger('tideng','提灯周年庆_中转页')
    this.record = bl
  },
  methods: {
    goBookPage () {
      this.record.sum('提灯周年庆中转页_新服预约按钮')
      this.$router.push('/anniversaryCelebration/appointment');
    },
    goActivty () {
      this.record.sum('提灯周年庆中转页_周年庆生按钮')
      if (!this.list.is_activity_start) {
        return Toast('周年活动将于3月2日正式开启~')
      }
      this.$router.push('/anniversary/index');
    },
    initList () {
      init().then(res => {
        this.list = res.data;
      });
    },
    // 前往官网
    goWeb () {
      window.location.href = 'https://tideng.qingcigame.com/leading/';
    },
    ...mapActions([
      'setShare'
    ])
  }
};
</script>
<style lang="less" scoped>
@import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/tideng/anniversaryCelebration/index/index.vue